var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoundCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f50;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SoundCloud"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    className: "cls-1",
    cx: 107.5,
    cy: 107.5,
    r: 107.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "SoundCloud-2",
    "data-name": "SoundCloud"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SoundCloud-3",
    "data-name": "SoundCloud",
    className: "cls-2",
    d: "M1449.24,934.31a1.46,1.46,0,0,0-1.75,1.1,96.34,96.34,0,0,0,0,29.81,1.47,1.47,0,0,0,2.86,0,96.34,96.34,0,0,0,0-29.81A1.47,1.47,0,0,0,1449.24,934.31Z",
    transform: "translate(-1385 -831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SoundCloud-4",
    "data-name": "SoundCloud",
    className: "cls-2",
    d: "M1440.44,933a1.38,1.38,0,0,0-1.68,1,90.51,90.51,0,0,0,0,30,1.38,1.38,0,0,0,2.68,0,90.51,90.51,0,0,0,0-30A1.37,1.37,0,0,0,1440.44,933Z",
    transform: "translate(-1385 -831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SoundCloud-5",
    "data-name": "SoundCloud",
    className: "cls-2",
    d: "M1458.07,924.63a1.48,1.48,0,0,0-1.69,1.21,169.41,169.41,0,0,0,0,39.24,1.47,1.47,0,0,0,2.9,0h0a169.41,169.41,0,0,0,0-39.24A1.48,1.48,0,0,0,1458.07,924.63Z",
    transform: "translate(-1385 -831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SoundCloud-6",
    "data-name": "SoundCloud",
    className: "cls-2",
    d: "M1431.81,938.09a1.48,1.48,0,0,0-1.88.91,42.48,42.48,0,0,0,0,20,1.48,1.48,0,0,0,2.79,0,42.82,42.82,0,0,0,0-20A1.49,1.49,0,0,0,1431.81,938.09Z",
    transform: "translate(-1385 -831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SoundCloud-7",
    "data-name": "SoundCloud",
    className: "cls-2",
    d: "M1475.71,922.15a1.65,1.65,0,0,0-1.85,1.41,208.32,208.32,0,0,0,0,41.38,1.64,1.64,0,0,0,3.26,0,208.32,208.32,0,0,0,0-41.38A1.65,1.65,0,0,0,1475.71,922.15Z",
    transform: "translate(-1385 -831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SoundCloud-8",
    "data-name": "SoundCloud",
    className: "cls-2",
    d: "M1467,921.08a1.62,1.62,0,0,0-1.83,1.38,204.73,204.73,0,0,0,0,42.58,1.62,1.62,0,0,0,3.22,0,206.58,206.58,0,0,0,0-42.58A1.63,1.63,0,0,0,1467,921.08Z",
    transform: "translate(-1385 -831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SoundCloud-9",
    "data-name": "SoundCloud",
    className: "cls-2",
    d: "M1534.5,931.78a29.67,29.67,0,0,0-40.7-20.46,4.65,4.65,0,0,0-2.8,4.26v47a3.44,3.44,0,0,0,3.44,3.44h44.46a17.12,17.12,0,0,0,4.39-.57,17.39,17.39,0,1,0-8.79-33.65Z",
    transform: "translate(-1385 -831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SoundCloud-10",
    "data-name": "SoundCloud",
    className: "cls-2",
    d: "M1484.65,916.64a1.65,1.65,0,0,0-1.84,1.46,268.69,268.69,0,0,0,0,46.78,1.66,1.66,0,0,0,3.29,0,268.69,268.69,0,0,0,0-46.78A1.65,1.65,0,0,0,1484.65,916.64Z",
    transform: "translate(-1385 -831)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundCloud);
export default __webpack_public_path__ + "static/media/SoundCloud.2c5158f2d93fd5d9eadc16b55b5abcec.svg";
export { ForwardRef as ReactComponent };